export default "__VITE_ASSET__DHqxj7zz__"